module.exports = __webpack_public_path__ + "img/footer_code.1c89253d.png";